<template>
    <base-dashboard-view class="settings">
        <div class="settings-wrap">
            <div class="settings-nav">
                <h2>Settings</h2>
                <div class="settings-menu icon-menu">
                    <ul>
                        <li>
                            <router-link to="/settings">
                                <i class="fal fa-cog" /> Account
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/settings/profile">
                                <i class="fal fa-address-card" /> Profile
                            </router-link>
                        </li>
                        <li v-if="user.pro">
                            <router-link to="/settings/billing">
                                <i class="fal fa-credit-card" /> Billing
                            </router-link>
                        </li>
                        <li v-if="user.pro && !isOnlyLifetime">
                            <router-link to="/settings/sites">
                                <i class="fal fa-browser" /> Sites
                            </router-link>
                        </li>
                        <template v-if="subscriptions.length > 0">
                            <li v-for="subscription in subscriptions" :key="subscription.id">
                                <router-link :to="`/settings/billing/lifetime/${subscription.id}`">
                                    <i class="fal fa-star" /> Lifetime
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
            <div class="settings-content">
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <router-view />
                </transition>
            </div>
        </div>
    </base-dashboard-view>
</template>

<script>
import { mapState } from 'vuex';
import subscriptionsList from '@/mixins/subscriptionsList';
import { filter } from 'lodash';

export default {
    mixins: [subscriptionsList],

    data: () => ({
        isSideNav: true,
    }),

    computed: {
        ...mapState([
            'user',
            'licenses',
        ]),

        /**
         * If user has only lifetime licenses
         *
         * @returns  {[boolean]}  If has only lifetime licenses
         */
        isOnlyLifetime() {
            return 0 === filter(this.licenses, license => 'lifetime' !== license.type).length;
        },
    },
};
</script>
